// PreviewContext.jsx
import React, { createContext, useEffect, useState } from 'react';
import { useWallet } from './WalletContextProvider';
import { getArtPackById, getBackgrounds, getPatterns } from '../utils/services';
import { useMemo } from 'react';
import { useGlobal } from './GlobalContextProvider';

import card_top_img from "../assets/images/card_top-box.svg";
import nft_cards_default from '../icons/nft-cards-default.svg';

export const PreviewContext = createContext(null);

const initialDataHeaderPreview = {
  web_main_color: "",
  secondary_color: "",
  main_text_color: "",
  light_text_color: "",
  gradient_color_1: "",
  gradient_color_2: "",
  art_pack_id: 0,
  nft_name: "",
  ct_social_link_1: "",
  ct_social_link_2: "",
  ct_social_link_3: "",
  ct_social_link_4: "",
  ct_main_logo: "",
  max_count: 0,
  imageBuffer: {
    ct_icon_1: "",
    ct_icon_2: "",
    ct_icon_3: "",
    ct_icon_4: "",
    ct_icon_5: "",
    ct_icon_6: "",
    ct_icon_nft: "",
    ct_about_icon_1: "",
    ct_about_icon_2: "",
    ct_about_icon_3: "",
    ct_about_icon_4: "",
  },
  footerImages: {},
  filterData: {
    artistBackground: [],
    pattern: [],
  },
};

export const PreviewProvider = ({ children }) => {
  const { account } = useWallet();
  const { userType, campaign, artPack, setArtPack, setSpinner } = useGlobal();
  const [data, setData] = useState(initialDataHeaderPreview);
  const [previewCard, updatePreviewCard] = useState([]);
  const [heroNfts, setHeroNfts] = useState([]);


  const createSamplePreview = async (previewData) => {
    let previewCards = [];
    let heroCards = [];
    previewData.map(async (pd) => {
      const imagereq = await fetch(`/api/file/name/${pd.image}`);
      const imagedata = await imagereq.json();
      let binaryString = "";
      const arrayBuffer = new Uint8Array(imagedata.image.data);
      for (let i = 0; i < arrayBuffer.length; i++) {
        binaryString += String.fromCharCode(arrayBuffer[i]);
      }
      const imageBase64 = btoa(binaryString);
      let samplePreview = {
        id: `${imagedata.id}-${pd.preview_nft_data_id}`,
        name: pd.nft_name,
        price: pd.price,
        image: `data:image/png;base64,${imageBase64}`,
        tokenId: 1,
        siteTokenIndex: 1,
        distPresetName: pd.preset_name,
        forSale: Math.random() < 0.5,
        originalPrice: pd.price,
        address: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
      };
      let sampleHeroCard = {
        name: pd.nft_name,
        image: `data:image/png;base64,${imageBase64}`,
        currentOwner: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
        tokenId: pd.preview_nft_data_id,
      };
      previewCards.push(samplePreview);
      heroCards.push(sampleHeroCard);
      updatePreviewCard(previewCards);
      setHeroNfts(heroCards);
    });
  };


  const createFakePreview = async () => {
    setHeroNfts([
      {
        name: "NFT #1",
        image: card_top_img,
        currentOwner: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
        tokenId: 5,
      },
      {
        name: "NFT #2",
        image: card_top_img,
        currentOwner: "0xAA50918e59793122C53Fc3A39F941eA6d5264307",
        tokenId: 6,
      },
      {
        name: "NFT #3",
        image: card_top_img,
        currentOwner: "0x7fb05B57b0709593aA7b6427a9A6c658A599499b",
        tokenId: 7,
      },
    ]);
  };

  useEffect(() => {

    setHeroNfts([
      {
        name: "NFT #1",
        image: previewCard[0]?.image || card_top_img,
        currentOwner: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
        tokenId: 5,
      },
      {
        name: "NFT #2",
        image: previewCard[1]?.image || card_top_img,
        currentOwner: "0xAA50918e59793122C53Fc3A39F941eA6d5264307",
        tokenId: 6,
      },
      {
        name: "NFT #3",
        image: previewCard[2]?.image || card_top_img,
        currentOwner: "0x7fb05B57b0709593aA7b6427a9A6c658A599499b",
        tokenId: 7,
      },
    ]);
   }, [previewCard]);

  useEffect(() => {
    const fetchData = async (url) => {
      try {
        setSpinner(true);
        const res = await fetch(url);
        if (!res.ok) throw new Error('Failed to fetch');

        const data = await res.json();


        // Destructure with defaults
        const {
          art_pack_id,
          nft_name_plural = "NFTs",
          nft_name = "NFT",
          ct_icon_nft = nft_cards_default,
          ct_about_faqs = "More Answers to Common Questions",
          ct_about_title_1 = 'You mint, you decide',
          beneficiaries = [],
          ...restData
        } = data.data;
        if (artPack?.art_pack_id) {
          const artPackData = await getArtPackById(account, artPack?.art_pack_id)
          setArtPack(artPackData)
        }

        const beneficiaryName = beneficiaries[0]?.beneficiary_name || "the beneficiary";

        // Lazy-load images
        // Lazy-load images
        const iconPromises = Object.keys(initialDataHeaderPreview.imageBuffer).map((icon) => {
          return data.data[icon]
            ? fetch(`/api/file/name/${data.data[icon]}`)
              .then((req) => req.json())
              .then((data2) => ({ [icon]: data2.image }))
            : Promise.resolve({ [icon]: "" }); // Add an empty entry for missing icons
        });

        const imageBuffer = (await Promise.all(iconPromises)).reduce(
          (acc, img) => ({ ...acc, ...img }),
          {}
        );
        setData({
          nft_name_plural,
          nft_name,
          beneficiary_name: beneficiaryName,
          ct_icon_nft,
          ct_about_faqs,
          ct_about_title_1,
          hero: data.hero,
          imageBuffer,
          footerImages: {
            svg1: data.svg1,
            svg2: data.svg2
          },
          ...restData  // Spread the rest of the destructured data directly
        });
        setSpinner(false);
      } catch (err) {
        setSpinner(false);
        console.error('Error:', err);
      }
    };

    if (userType === "preview" && campaign) fetchData(`/api/preview/home/${campaign.campaign_id}`);
  }, [userType, campaign]);


  useEffect(() => {
    const getData = async (url) => {

      if (!artPack?.art_pack_id) {
        return;
      }
      try {
        setSpinner(true);
        const background = await getBackgrounds(campaign?.campaign_id, artPack?.art_pack_id);
        const patterns = await getPatterns(artPack?.art_pack_id);
        let filterData = {};
        filterData.artistBackground = background
          .map((item, i) => {
            return {
              id: i,
              style: {
                backgroundColor: item.color_hex_code,
              },
              selected: false,
              key: `bgcolor`,
            };
          });

        filterData.pattern = patterns.map((item, i) => {
          return {
            id: i,
            name: item.pattern_name,
            style: {
              backgroundImage: `url(${item.thumbnail_url})`,
              backgroundPosition: "center",
            },
            selected: false,
            key: `pattern`,
          };
        });
        setData((prevData) => ({
          ...prevData,
          filterData: {
            ...prevData.filterData,
            ...filterData,
          },
        }));
        setSpinner(false);
      } catch (err) {
        setSpinner(false);
        console.error("Error fetching data:", err);
      }
    };
    if(userType === "preview") getData();
  }, [userType, campaign, artPack]);

  useEffect(() => {
    const getData = async () => {
      if (campaign?.campaign_id) {
        const previewDataRes = await fetch(
          `/api/mintpreview/previewnftdata/${campaign?.campaign_id}`
        );
        if (previewDataRes.status === 204 || !previewDataRes.ok) {
          await createFakePreview();
          return;
        }
        const previewData = await previewDataRes.json();
        if (previewData.length === 0) {
          await createFakePreview();
        } else {
          await createSamplePreview(previewData);
        }
      }
      else {
        updatePreviewCard([])
        await createFakePreview()
      }
    };
    if(userType === "preview") getData();
  }, [userType, campaign]);

  const value = useMemo(() => {
    return {
      data,
      campaign,
      artPack,
      account,
      previewCard,
      updatePreviewCard,
      heroNfts
    };
  }, [data, campaign, artPack, account, previewCard, heroNfts]);

  return (
    <PreviewContext.Provider value={value}>
      {children}
    </PreviewContext.Provider>
  );
};

export const usePreview = () => {
  const context = React.useContext(PreviewContext);
  if (context === undefined) {
    throw new Error('usePreview must be used within a PreviewProvider');
  }
  return context;
} 